import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { before, after } from "../../data/landing";
export function BeforeAfter() {
  return <section className="bg-white px-4 py-16 sm:py-20" data-id="element-86" data-mp="26m32bt19lnhu">
      <div className="mx-auto max-w-5xl" data-id="element-87" data-mp="26mmawj50yzj7">
        <h2 className="text-center font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-88" data-mp="22l10d4fyqxc6">
          What professionals should be able to do <em className="italic text-skydeep" data-id="element-89" data-mp="2za8rcrzcpynh">after using the system</em>
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-90" data-mp="2ud8he5zdsbr3">
          <div className="rounded-3xl bg-danger/[0.06] p-6 ring-1 ring-danger/20 sm:p-8" data-id="element-91" data-mp="2qa3lwndpxaby">
            <h3 className="text-center text-lg font-black uppercase tracking-[0.2em] text-danger" data-id="element-92" data-mp="2lbitvb8mdwyl">Before</h3>
            <ul className="mt-5 space-y-3" data-id="element-93" data-mp="1evpytkqsgywz">
              {before.map(t => <li key={t} className="flex items-start gap-3 text-[16px] leading-snug text-ink/85" data-id="element-94" data-mp="19w3l7a71tgnn">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-danger text-white" data-id="element-95" data-mp="175clk0t409i0">
                    <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-96" data-mp="1c4pacr3jjqn8" />
                  </span>
                  {t}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-navy p-6 text-white sm:p-8" data-id="element-97" data-mp="133it2ft2ibsx">
            <h3 className="text-center text-lg font-black uppercase tracking-[0.2em] text-sky" data-id="element-98" data-mp="135lq3jsn1575">After</h3>
            <ul className="mt-5 space-y-3" data-id="element-99" data-mp="od1o4mh853ra">
              {after.map(t => <li key={t} className="flex items-start gap-3 text-[16px] font-medium leading-snug" data-id="element-100" data-mp="t6w9duch9qsh">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-101" data-mp="fc3jq32viu86">
                    <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-102" data-mp="5g0lv9f21hr1" />
                  </span>
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-103" data-mp="2c49aso80h3jy">
          <p className="font-display text-2xl font-extrabold leading-snug text-navy" data-id="element-104" data-mp="2c5kb2e28zt6b">The goal isn't to give you more information.</p>
          <p className="mt-2 text-[17px] text-ink/75" data-id="element-105" data-mp="23byyn1dk2o02">The goal is to help you get more value from the information you already have.</p>
        </div>
        <div className="mt-10" data-id="element-106" data-mp="1ye5pq0kvbfw3">
          <CTAButton label="I want to make this change" data-id="element-107" data-mp="1yb1g2nomvry1" />
        </div>
      </div>
    </section>;
}